import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const getTopPartnerIdSource = () => {
  const crud = CrudStore.get(CrudStoreItem.PartnerAllData, 'getTopPartnerIdSource')
  const filter: IDataProviderFilter = {
    logic: Logic.AND,
    filters: [
      {
        field: 'HierarchyType',
        operator: Operator.CONTAINS,
        value: PartnerHierarchyType.HEADQUARTERS,
      },
    ],
  }
  crud.setFilter(filter)
  crud.setSort({ field: 'PartnerID', dir: 'asc' })
  crud.keyField = 'PartnerID'
  return crud
}
